import React from 'react';
import '../styles/AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>Hakkımızda</h1>
          <p className="about-description">
            5N1PR İletişim Danışmanlığı olarak, markanızın hikayesini en etkili şekilde anlatmanıza yardımcı oluyoruz.
          </p>
        </div>
      </section>
      
      <section className="about-story">
        <div className="container">
            <p>
              2016 yılında kurulan 5N1PR İletişim Danışmanlığı, kurulduğu günden bu yana iletişim dünyasının hızla değişen dinamiklerine uyum sağlayarak sürekli gelişen bir yapı sergilemiştir. Deneyimli, yaratıcı ve enerjisi yüksek ekibimizle, markaların yalnızca bugünkü ihtiyaçlarına değil, gelecekteki iletişim stratejilerine de yön veriyoruz.
< br ></br>< br ></br>
5N1PR, klasik halkla ilişkiler hizmetinin ötesine geçerek; medya ilişkilerinden kriz yönetimine, stratejik iletişimden kurumsal itibara kadar geniş bir yelpazede danışmanlık sunuyor. Markalarla medya arasında güvene dayalı bir köprü kurarken, farkındalık yaratan içerikler ve özgün iletişim kampanyalarıyla müşterilerinin sesini en doğru şekilde duyurmayı hedefliyor.
< br ></br>< br ></br>
Zamanla edindiğimiz tecrübe ve öngörüyle hizmet alanlarımızı da genişlettik.< br ></br>< br ></br> Bugün 5N1PR olarak;< br ></br>
	•	Halkla ilişkiler ve medya iletişimi< br ></br>
	•	Sosyal medya yönetimi ve dijital içerik üretimi< br ></br>
	•	Prodüksiyon ve video içerik hizmetleri< br ></br>
	•	Profesyonel stüdyo hizmetleri (çekim, kurgu, yayın vb.)< br ></br>
	•	Etkinlik ve organizasyon planlaması
< br ></br>
alanlarında uçtan uca entegre iletişim çözümleri sunuyoruz.
< br ></br>< br ></br>
İletişimin tek yönlü değil, etkileşimli ve çok katmanlı olduğu bir çağda; biz de markalarımızla birlikte dönüşüyor, onların hedef kitleleriyle daha güçlü bağlar kurmalarını sağlıyoruz. 5N1PR, strateji, yaratıcılık ve operasyonel güç üçgeninde; ölçülebilir, özgün ve sürdürülebilir projelerle markalara değer katmaya devam ediyor.
              5N1PR, iletişim dünyasında fark yaratmak isteyen deneyimli profesyoneller tarafından kurulmuştur. 
              Adımızı, iletişimin temel sorularından alan şirketimiz (5N: Ne, Nerede, Ne zaman, Nasıl, Neden ve 1K: Kim), 
              bu soruların her birine en doğru yanıtları vererek müşterilerimizin iletişim stratejilerini mükemmelleştirmeyi hedefliyor.
            </p>
        </div>
      </section>
      
      <section className="about-values">
        <div className="container">
          <h2 className="section-title">Değerlerimiz</h2>
          <div className="values-grid">
            <div className="value-card">
              <h3>Yaratıcılık</h3>
              <p>Sıradanlığın ötesine geçen, özgün ve etkileyici iletişim çözümleri üretiyoruz.</p>
            </div>
            <div className="value-card">
              <h3>Şeffaflık</h3>
              <p>Müşterilerimizle açık ve dürüst iletişim kurarak güvene dayalı ilişkiler geliştiriyoruz.</p>
            </div>
            <div className="value-card">
              <h3>Sonuç Odaklılık</h3>
              <p>Her projede ölçülebilir sonuçlar elde etmeyi ve gerçek değer yaratmayı hedefliyoruz.</p>
            </div>
            <div className="value-card">
              <h3>Uyarlanabilirlik</h3>
              <p>Değişen iletişim trendlerine ve teknolojilerine hızla adapte olarak güncel kalıyoruz.</p>
            </div>
          </div>
        </div>
      </section>
      
     {/* <section className="about-team">
        <div className="container">
          <h2 className="section-title">Ekibimiz</h2>
          <p className="team-description">
            5N1PR'ın arkasındaki güç, deneyimli ve tutkulu profesyonellerden oluşan ekibimizdir. 
            Her biri kendi alanında uzman olan ekip üyelerimiz, müşterilerimize en iyi hizmeti sunmak için çalışıyor.
          </p>
          <div className="team-grid">
            <div className="team-member">
              <div className="member-photo"></div>
              <h3>Ayşe Yılmaz</h3>
              <p className="member-title">Kurucu & Genel Müdür</p>
            </div>
            <div className="team-member">
              <div className="member-photo"></div>
              <h3>Mehmet Kaya</h3>
              <p className="member-title">Kreatif Direktör</p>
            </div>
            <div className="team-member">
              <div className="member-photo"></div>
              <h3>Zeynep Demir</h3>
              <p className="member-title">PR Direktörü</p>
            </div>
            <div className="team-member">
              <div className="member-photo"></div>
              <h3>Can Öztürk</h3>
              <p className="member-title">Sosyal Medya Uzmanı</p>
            </div>
          </div>
        </div>
      </section>*/}
      
      <section className="about-why-us">
        <div className="container">
          <div className="why-us-content">
            <h2>Neden 5N1PR?</h2>
            <ul className="why-us-list">
              <li>
                <strong>Deneyimli Ekip:</strong> Sektörde uzun yıllar deneyime sahip profesyonellerden oluşan ekibimiz
              </li>
              <li>
                <strong>Kişiselleştirilmiş Yaklaşım:</strong> Her müşterinin benzersiz ihtiyaçlarına özel çözümler
              </li>
              <li>
                <strong>Bütünsel Hizmet:</strong> İletişimin tüm alanlarında A'dan Z'ye çözümler
              </li>
              <li>
                <strong>Ölçülebilir Sonuçlar:</strong> Veri odaklı yaklaşımla somut başarı göstergeleri
              </li>
              <li>
                <strong>Yaratıcı Stratejiler:</strong> Sıradanlığın ötesine geçen, fark yaratan iletişim stratejileri
              </li>
            </ul>
          </div>
        </div>
      </section>
      
      <section className="contact-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Projeleriniz İçin Bizimle İletişime Geçin</h2>
            <p>
              Markanızı bir sonraki seviyeye taşımak için hazırız. 
              Hemen iletişime geçin ve projeleriniz hakkında konuşalım.
            </p>
            <a href="/iletisim" className="btn btn-primary">İletişime Geç</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;